export default "__VITE_ASSET__CEMa$VZq__"